import React from 'react';
import { Avatar, Icon, StatusChip } from '../components/sp-primitives';
import { PShell, useApp } from '../components/sp-shell';

function permMod(p) {
  if (p === 'Administrador') return 'admin';
  if (p === 'Aprovador') return 'approve';
  return 'upload';
}

function formatLastAccess(value) {
  if (!value) return 'Nunca Acessou';
  const dt = new Date(value);
  if (Number.isNaN(dt.getTime())) return 'Nunca Acessou';
  return dt.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function PUsers() {
  const app = useApp();
  const canCreateUser = Array.isArray(app.currentUser?.permissions) && app.currentUser.permissions.includes('Administrador');
  const roleLabel = (role) => {
    if (role === 'manager') return 'Admin Master';
    if (role === 'analyst') return 'Operacional';
    return role || 'Usuário';
  };
  const rolePerms = (permissions) => {
    const perms = Array.isArray(permissions)
      ? permissions.filter((p) => ['Registrador', 'Aprovador', 'Administrador'].includes(p))
      : [];
    return perms.length ? perms : ['Registrador'];
  };

  const users = app.users.map((u) => ({
    ...u,
    roleLabel: roleLabel(u.role),
    perms: rolePerms(u.permissions),
    last: formatLastAccess(u.last_access_at),
    status: u.status || 'active',
  }));

  const uploadCount = users.filter((u) => u.perms.includes('Registrador')).length;
  const approveCount = users.filter((u) => u.perms.includes('Aprovador')).length;
  const adminCount = users.filter((u) => u.perms.includes('Administrador')).length;

  return (
    <PShell active="users">
      <div className="sp-screen-head">
        <div>
          <h1 className="sp-screen-head__title">Usuários</h1>
          <div className="sp-screen-head__meta">Gerencie usuários do sistema</div>
        </div>
        {canCreateUser && (
          <button type="button" className="sp-btn sp-btn-accent" onClick={() => app.navigate('profile', { newUser: true })}>
            <Icon name="plus" size={13} /> Criar novo usuário
          </button>
        )}
      </div>

      <div className="sp-users-kpi-grid">
        {[['Podem registrar pagamentos', uploadCount, 'Registrador'], ['Podem registrar e aprovar pagamentos', approveCount, 'Aprovador'], ['Administradores', adminCount, 'Administrador']].map(([l, n, p], i) => (
          <div key={i} className="sp-card sp-users-kpi">
            <div className={`sp-perm-stat-icon sp-perm-stat-icon--${permMod(p)}`}>{p}</div>
            <div>
              <div className="sp-num sp-users-kpi-value">{n}</div>
              <div className="sp-users-kpi-label">{l}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="sp-card sp-card-flush">
        <table className="sp-table">
          <thead><tr><th>Usuário</th><th>Departamento</th><th>Função</th><th>Permissões</th><th>Último acesso</th><th>Status</th><th /></tr></thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>
                  <div className="sp-user-cell">
                    <Avatar name={u.name} size={30} src={u.avatar_data || ''} />
                    <div>
                      <div className="sp-user-name">{u.name}</div>
                      <div className="sp-mono sp-user-email">{u.email}</div>
                    </div>
                  </div>
                </td>
                <td>{u.department || '—'}</td>
                <td className="sp-td-role">{u.roleLabel}</td>
                <td>
                  <div className="sp-perm-chips">
                    {u.perms.map((p) => (
                      <span key={p} className={`sp-chip sp-chip-perm sp-chip-perm--${permMod(p)}`}>{p}</span>
                    ))}
                  </div>
                </td>
                <td className="sp-mono sp-td-date">{u.last}</td>
                <td>{u.status === 'active' ? <StatusChip kind="green">ativo</StatusChip> : <StatusChip kind="red">inativo</StatusChip>}</td>
                <td className="sp-td-actions">
                  <button
                    type="button"
                    className="sp-btn sp-btn-ghost sp-btn-row-action sp-btn-row-action--padx"
                    onClick={() => app.navigate('profile', { userId: u.id })}
                  >
                    Detalhes <Icon name="chevron" size={11} />
                  </button>
                </td>
              </tr>
            ))}
            {users.length === 0 && (
              <tr>
                <td colSpan="7" className="sp-td-empty">Nenhum usuário cadastrado.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </PShell>
  );
}
